import { render, staticRenderFns } from "./OmsChangePasswordForm.vue?vue&type=template&id=2967d89f"
import script from "./OmsChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./OmsChangePasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports